'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fCheckBox$002ejs from "@ui5/webcomponents/dist/CheckBox.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_CheckBox$() {
  this.CQ = null;
  $n_Lbe_doeraene_webcomponents_ui5_CheckBox$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fCheckBox$002ejs.default;
  this.CQ = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-checkbox", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_CheckBox$ as $c_Lbe_doeraene_webcomponents_ui5_CheckBox$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_CheckBox$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_CheckBox$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_CheckBox$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_CheckBox$ as $h_Lbe_doeraene_webcomponents_ui5_CheckBox$ };
$h_Lbe_doeraene_webcomponents_ui5_CheckBox$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.CQ;
});
var $d_Lbe_doeraene_webcomponents_ui5_CheckBox$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_CheckBox$, "be.doeraene.webcomponents.ui5.CheckBox$", ({
  ge: 1,
  ar: 1,
  bk: 1,
  b8: 1,
  c0: 1,
  cI: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_CheckBox$ as $d_Lbe_doeraene_webcomponents_ui5_CheckBox$ };
var $n_Lbe_doeraene_webcomponents_ui5_CheckBox$;
function $m_Lbe_doeraene_webcomponents_ui5_CheckBox$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_CheckBox$)) {
    $n_Lbe_doeraene_webcomponents_ui5_CheckBox$ = new $c_Lbe_doeraene_webcomponents_ui5_CheckBox$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_CheckBox$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_CheckBox$ as $m_Lbe_doeraene_webcomponents_ui5_CheckBox$ };
